export const passwordCriteria = [
  {
    condition: (value: string) => value.length >= 8,
    message: '8 characters.',
    met: false,
    isVisible: true,
  },
  {
    condition: (value: string) => /[A-Z]/.test(value),
    message: '1 uppercase letter.',
    met: false,
    isVisible: true,
  },
  {
    condition: (value: string) => /[a-z]/.test(value),
    message: '1 lowercase letter.',
    met: false,
    isVisible: true,
  },
  {
    condition: (value: string) => /[0-9]/.test(value),
    message: '1 number.',
    met: false,
    isVisible: true,
  },
  {
    condition: (value: string) => /[!@#$%^&*(),.?":{}|<>]/.test(value),
    message: '1 special character.',
    met: false,
    isVisible: true,
  },
  {
    condition: (value: string) => value.length >= 10,
    message: '10 characters.',
    met: false,
    isVisible: false,
  },

  {
    condition: (value: string) => {
      const criteria = [
        /[A-Z]/.test(value),
        /[a-z]/.test(value),
        /[0-9]/.test(value),
        /[!@#$%^&*(),.?":{}|<>]/.test(value),
      ]
      return criteria.filter(Boolean).length >= 3
    },
    message: 'At least 3 of 4 types of characters (for Good and Excellent).',
    met: false,
    isVisible: false,
  },
  {
    condition: (value: string) => {
      return !/(.)\1{2,}/.test(value)
    },
    message: 'No more than 2 identical characters in a row (for Excellent).',
    met: false,
    isVisible: false,
  },
]

export const getProgress = (password: string) => {
  const hasMinimumLength = password.length >= 8
  const hasExcellentLength = password.length >= 10
  const hasUpperCase = /[A-Z]/.test(password)
  const hasLowerCase = /[a-z]/.test(password)
  const hasNumber = /[0-9]/.test(password)
  const hasSpecialChar = /[!@#$%^&*(),.?":{}|<>]/.test(password)
  const meetsGoodCriteria =
    [hasUpperCase, hasLowerCase, hasNumber, hasSpecialChar].filter(Boolean).length === 4
  const hasNoIdenticalCharsInRow = !/(.)\1{2,}/.test(password)

  if (hasExcellentLength && meetsGoodCriteria && hasNoIdenticalCharsInRow) return 'excellent'
  if (hasMinimumLength && meetsGoodCriteria) return 'strong'
  if (hasMinimumLength && [hasUpperCase, hasLowerCase, hasNumber].filter(Boolean).length >= 2)
    return 'weak'
  if (password.length >= 1) return 'weak'
  return ''
}
